import React from 'react';

const style = {
    "fontFamily": "FontAwesome",
    "fontSize": "13px",
    "top": "15px",
    "position": "absolute",
    "right": "18px",
    "borderRadius": "50%",
    "width": "36px",
    "height": "36px",
    "display": "flex",
    "WebkitBoxAlign": "center",
    "MsFlexAlign": "center",
    "alignItems": "center",
    "WebkitBoxPack": "center",
    "MsFlexPack": "center",
    "justifyContent": "center",
    "textAlign": "center",
    "backgroundColor": "rgba(0, 0, 0, .4)",
    "color": "#fff",
    "opacity": "1",
    "cursor": "zoom-in"
};

export default function ({url}) {

    return(
        <div className="my-5 grid lightbox" data-columns="1" data-gutter="0" data-cell-ratio="5/4">
            <a href={url} className="portfolio-item lightbox-link" data-background={url} style={{"cursor":"zoom-in"}}>
                <span className="fas fa-expand" style={style}/>
            </a>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/post/sections/ZoomableImage.js